import React from "react";
import { CallManager } from "../components/Call/CallManager";
import CallHistory from "../components/Call/CallHistory";

const Calls: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Phone Calls</h1>
        <p className="text-gray-600 mt-1">Make calls and view transcriptions</p>
      </div>

      <div className="space-y-6">
        <CallManager />
        <CallHistory />
      </div>
    </div>
  );
};

export default Calls;
